import React, { useEffect, useState } from "react";
import styles from "./popup.module.scss";
import Image from "next/image";
import closeImg from "../../new-images/closeicon.svg";
import Button from "../newProfile/ui/button/Button";
import { Props } from "./IProps";
import { inject, observer } from "mobx-react";
import moment from "moment";
import setCookie from "../../hooks/setCookie";

const Popup: React.FC<Props> = (props) => {
  const {
    donationsBeforeRegStore,
    triggerStore,
    dateJoined,
    setIsPopup,
    setTriggerInfo,
  } = props;
  const [countDonations, setCountDonations] = useState("");
  const [error, setError] = useState("");
  const oldUser = {
    content: (
      <div className={styles.PopupContent}>
        <h2 className={styles.PopupContentTitle}>
          Добро пожаловать в обновленный личный кабинет
          <span> DonorSearch</span>!
        </h2>
        <p>
          Мы проводим исследование влияния DonorSearch на донорство, укажите
          пожалуйста, сколько у вас было донаций на момент регистрации в
          DonorSearch.
        </p>
        <ul>
          <li>
            В случае, если вы не помните точное число, укажите приблизительно.
          </li>
          <li>
            Если на момент регистрации вы еще не были донором, поставьте “0”.
          </li>
        </ul>
      </div>
    ),
  };
  const newUser = {
    content: (
      <div className={styles.PopupContent}>
        <h2 className={styles.PopupContentTitle}>
          Добро пожаловать
          <br /> в личный кабинет
          <span> DonorSearch</span>!
        </h2>
        <p>Скажите, пожалуйста, сколько донаций у вас на данный момент?</p>
        <ul>
          <li>
            В случае, если вы не помните точное число, укажите приблизительно.
          </li>
          <li>
            Если на момент регистрации вы еще не были донором, поставьте “0”.
          </li>
        </ul>
      </div>
    ),
  };

  // Делаю запрос для триггерного баннера, чтоб перерендерилась карточка
  const getTriggerInfo = () => {
    triggerStore
      .loadTrigger()
      .then((data) => setTriggerInfo(data))
      .catch((err) => console.log(err));
  };

  // Отправка кол-ва донаций пользователя
  const handleSendDonations = () => {
    donationsBeforeRegStore
      .sendCountDonations({
        donations_before_reg: countDonations,
      })
      .then(() => {
        setError("");
        setIsPopup(false);
        getTriggerInfo();
      })
      .catch((err) => setError(err.response.data?.donations_before_reg[0]));
  };

  const handleChangeCount = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCountDonations(e.target.value);
  };

  const handleClosePopup = (e) => {
    if (e.target === e.currentTarget) {
      setIsPopup(false);
      setCookie("CountDonationsPopup", true);
      getTriggerInfo();
    }
  };

  useEffect(() => {
    const closeByEscape = (e) => {
      if (e.key === "Escape") {
        setIsPopup(false);
        setCookie("CountDonationsPopup", true);
        getTriggerInfo();
      }
    };
    document.addEventListener("keydown", closeByEscape);
    return () => document.removeEventListener("keydown", closeByEscape);
  }, []);

  // Зарагестрированный СЕГОДНЯ пользователь
  const today = moment().format("YYYY MM DD");
  // Зарегестрированный РАНЕЕ пользователь
  const registrationDate = moment(dateJoined).format("YYYY MM DD");

  return (
    <div className={styles.Overlay} onClick={handleClosePopup}>
      <div className={styles.Popup}>
        <div className={styles.PopupClose}>
          <Image
            src={closeImg}
            width={24}
            height={24}
            onClick={handleClosePopup}
          />
        </div>
        {today === registrationDate ? newUser.content : oldUser.content}
        <div>
          <div className={styles.PopupInputBlock}>
            <input
              className={`${styles.PopupInputBlockInput} ${
                error && styles.PopupInputBlockInput_error
              }`}
              value={countDonations}
              onChange={handleChangeCount}
              placeholder="Укажите число"
            />
            <span className={styles.PopupInputBlockError}>{error}</span>
          </div>

          <Button width="256px" onClick={handleSendDonations}>
            <span>Отправить</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default inject(
  "donationsBeforeRegStore",
  "triggerStore"
)(observer(Popup));
